(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.help', ['pp.widgets-templates']);

ngModule.directive('ppHelp', [function () {
    return {
        restrict: 'A',
        templateUrl: 'widgets/_angular/help/help.tpl.html',
        scope: {},
        controllerAs: 'vm',
        bindToController: true,
        controller: ['$scope', function ($scope) {
            var vm = this;

            // -- initial state

            // -- util functions

            // -- api

            // -- scope bindings

            // -- main

        }]
    };
}]);
})(window, window.angular);